<template>
     <form method="post" @submit.prevent="submitForm">
        <input type="hidden" name="InventoryRequestId" v-model="InventoryRequestId"/>
        <inventory-request-item-list ref="inventoryRequestObject" :items="items" :inventory-request-id="InventoryRequestId"></inventory-request-item-list>
        <input type="submit" class="btn btn-primary" value="submit"/>
    </form>
</template>
<script>
import InventoryRequestItemList from './InventoryRequestItemList.vue'
export default {
    name : 'inventory-request-form',
    props: ['items', 'InventoryRequestId'],
    components: {
        'inventory-request-item-list' : InventoryRequestItemList
    },
    data(){
        return {
            formData : {
                data : null
            },
            URLInventoryRequestItemPost: 'inventory-requests/items/store'
        }
    },
    methods:{
        submitForm: function(){
            this.formData.data = this.$refs.inventoryRequestObject.itemrows

            var unique = this.checkUniqueItems(this.$refs.inventoryRequestObject.itemrows, 'ItemId')
            this.$refs.inventoryRequestObject.itemrows = unique;

            // show message if duplicated items
            this.formData.data.map(v => v.ItemId).sort().sort((a, b) => {
                if (a === b) alert("We have removed duplicated items")
            })
            this.formData.data = this.$refs.inventoryRequestObject.itemrows
            this.formData['InventoryRequestId'] =  this.InventoryRequestId;
            this.formData['IsSupplyChain'] =  false;
            console.table(this.URLInventoryRequestItemPost)
            axios.post(this.URLInventoryRequestItemPost, this.formData)
                .then(response => {
                    console.table(response.data)
                    if(response.data.success){
                    Swal.fire({
                            title: response.data.message,
                            icon: 'success',
                        })
                    } else{
                        Swal.fire({
                            title: response.data.message + ' | ' + response.data.error_code,
                            icon: 'error',
                        })
                    }
                    window.location.reload();
                }).
            catch(error => {
                this.errored = true
            })
            .finally(() => this.loading = false)
        },

        checkUniqueItems: function(arr, key){
            var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
            return uniqueItems;
        }
    }
}
</script>
